import { render } from "./FooterDisplay.vue?vue&type=template&id=6daf749a&scoped=true"
import script from "./FooterDisplay.vue?vue&type=script&lang=js"
export * from "./FooterDisplay.vue?vue&type=script&lang=js"

import "./FooterDisplay.vue?vue&type=style&index=0&id=6daf749a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6daf749a"]])

export default __exports__